import type { ComponentProps } from 'react'
import { orgHref } from '../lib/public-router'
import { PaymentThanks } from '../ui'
import { GiveDone } from './GiveFrame'
import { KioskDoneOr } from './kiosk'

export function DonateThanks({
  thanks,
  orgId,
  orgName,
  onAnother,
  kiosk = false,
}: {
  thanks: ComponentProps<typeof PaymentThanks>['thanks']
  orgId: string
  orgName: string
  onAnother: () => void
  kiosk?: boolean
}) {
  return (
    <GiveDone>
      <PaymentThanks appearance="page" thanks={thanks}>
        {/* Both stay real addresses. Another donation also takes the finished
            gift off the page — a site that swaps pages in place leaves the
            thank-you standing otherwise. */}
        <KioskDoneOr kiosk={kiosk}>
          <a href={orgHref(orgId, '')}>Back to {orgName}</a>
          <a href={orgHref(orgId, 'donate')} onClick={onAnother}>
            Make another donation
          </a>
        </KioskDoneOr>
      </PaymentThanks>
    </GiveDone>
  )
}
